import React from 'react';
import { useSelector } from 'react-redux';

import Icon from 'components/DesignSystem/Icon';
import { selectTokenUserName } from 'redux/reducers/authReducer';
import getInitials from 'utils/getInitials';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function MobileSectionHeader({
  backLabel,
  title,
  onBack,
  onAvatarClick,
  action,
}: {
  backLabel: string;
  title: string;
  onBack: () => void;
  onAvatarClick: () => void;
  // Acao opcional da barra (ex.: download no Windx), a esquerda do avatar.
  // Omitida em todas as demais secoes — o DOM delas nao muda.
  action?: React.ReactNode;
}) {
  const userName = useSelector(selectTokenUserName);

  return (
    <header className="mobile-section-header">
      <button
        type="button"
        className="mobile-section-header-back"
        aria-label={`Voltar para ${backLabel}`}
        onClick={onBack}
      >
        <Icon
          iconType="left_arrow"
          color={cssVar('text-strong')}
          size="large"
          className="mobile-section-header-chevron"
        />
        <span className="mobile-section-header-labels">
          <span className="mobile-section-header-module">{backLabel}</span>
          <span className="mobile-section-header-tab">{title}</span>
        </span>
      </button>
      {action && <div className="mobile-section-header-action">{action}</div>}
      <button
        type="button"
        className="mobile-section-header-avatar"
        aria-label="Mais"
        onClick={onAvatarClick}
      >
        {getInitials(userName)}
      </button>
    </header>
  );
}
